const english = {
    'USER.Button_Text_Create': 'Create user',
    'USER.Button_Text_Delete': 'Delete User',
    'GROUP.Button_Text_Create': 'Create Group',
    'GROUP.Button_Text_Delete': 'Delete Group',
    'LANGUAGE.Button_Text_Create': 'Create Language',
    'LANGUAGE.Button_Text_Delete': 'Delete Language',
    'SUBCONTRACTOR.Button_Text_Create': 'Create Subcontractor',
    'SUBCONTRACTOR.Button_Text_Delete': 'Delete Subcontractor',
    'SUBCONTRACTOR.Button_Text_Import': 'Import Subcontractors',
    'STAND.Button_Text_Create': 'Create Stand',
    'STAND.Button_Text_Delete': 'Delete Stand',
    'EXHIBITION.Button_Text_Create': 'Create Exhibition',
    'EXHIBITION.Button_Text_Delete': 'Delete Exhibition',
    'EXHIBITION.Button_Text_Import': 'Import Exhibition',
    'JOB.Button_Text_Create': 'Create Job',
    'JOB.Button_Text_Add': 'add job',
    'JOB.Type_Text_Claim': 'MP Claim',
    'JOB.Type_Text_CustomerClaim': 'Customer Claims',
    'JOB.Type_Text_LastMinute': 'Last Minute',
    'JOB.Type_Text_Damage': 'Damage',
    'JOB.Type_Text_ProtocolDefect': 'Protocol Defect',
    'JOB.Status_Text_Open': 'Open',
    'JOB.Status_Text_InProgress': 'In progress',
    'JOB.Status_Text_Completed': 'Completed',
    'HALL.Button_Text_Create': 'Create Hall',
    'HALL.Button_Text_Delete': 'Delete Hall',
    'FURNISHING.Button_Text_AddFurnishing': 'Add Furnishing',
    'FURNISHING.Button_Text_FurnishingImport': 'FURNISHING IMPORT',
    'CRAFT.Button_Text_AddCraft': 'Add Craft',
    'CRAFT.Button_Text_CreateCraft': 'Create Craft',
    'GRAPHIC_PACKING.Button_Text_Create': 'Create new exhibition packing',
    'GRAPHIC_STAND.Button_Text_Create': 'Create Graphic Stand',
    'TABLES.Column_Title_Name': 'Name',
    'TABLES.Column_Title_Phone': 'Phone',
    'TABLES.Column_Title_Email': 'Email',
    'TABLES.Column_Title_Company': 'Company',
    'TABLES.Column_Title_UserGroup': 'User group',
    'TABLES.Column_Title_User': 'User',
    'TABLES.Column_Title_Exhibition': 'Exhibition',
    'TABLES.Column_Title_Time': 'Time',
    'TABLES.Column_Title_Hall': 'Hall',
    'TABLES.Column_Title_HallNew': 'Hall new',
    'TABLES.Column_Title_BlockNew': 'Block new',
    'TABLES.Column_Title_StandNew': 'Stand new',
    'TABLES.Column_Title_Halls': 'Halls',
    'TABLES.Column_Title_Comments': 'Comments',
    'TABLES.Column_Title_DamageFilesCount': 'Damage files',
    'TABLES.Column_Title_StandNumber': 'Stand №',
    'TABLES.Column_Title_Craft': 'Craft',
    'TABLES.Column_Title_Crafts': 'Crafts',
    'TABLES.Column_Title_JobNumber': 'Job №',
    'TABLES.Column_Title_Jobs': 'Jobs',
    'TABLES.Column_Title_JobTableNumber': 'number',
    'TABLES.Column_Title_CadNumber': 'Cad №',
    'TABLES.Column_Title_JobType': 'Job Type',
    'TABLES.Column_Title_Type': 'Type',
    'TABLES.Column_Title_Message': 'Message',
    'TABLES.Column_Title_Label': 'Label',
    'TABLES.Column_Title_Slug': 'Slug',
    'TABLES.Column_Title_GroupRights': 'Group Rights',
    'TABLES.Column_Title_NumberUsers': 'Number of users',
    'TABLES.Column_Title_NumberStands': 'Number of stands',
    'TABLES.Column_Title_Stands': 'Stands',
    'TABLES.Column_Title_Title': 'title',
    'TABLES.Column_Title_HallNumber': 'hall number',
    'TABLES.Column_Title_Number': 'number',
    'TABLES.Column_Title_Exhibitor': 'exhibitor',
    'TABLES.Column_Title_ExhibitionName': 'Exhibition Name',
    'TABLES.Column_Title_ExhibitionEvent': 'Exhibition Event',
    'TABLES.Column_Title_AcquiseNumber': 'acquisition',
    'TABLES.Column_Title_ProaufNumber': 'proauf',
    'TABLES.Column_Title_HallName': 'hall',
    'TABLES.Column_Title_Corridor': 'corridor',
    'TABLES.Column_Title_CorridorNew': 'Corridor New',
    'TABLES.Column_Title_Block': 'block',
    'TABLES.Column_Title_DeliveryTime': 'deadline',
    'TABLES.Column_Title_Materials': 'materials',
    'TABLES.Column_Title_Actions': 'Actions',
    'TABLES.Column_Title_Status': 'status',
    'TABLES.Column_Title_Description': 'description',
    'TABLES.Column_Title_Created': 'created',
    'TABLES.Column_Title_InProgress': 'in progress',
    'TABLES.Column_Title_Completed': 'completed',
    'TABLES.Column_Title_Attachments': 'attachments',
    'TABLES.Column_Title_Acqusition': 'acqusition',
    'TABLES.Column_Title_HallPlan': 'hall plan',
    'TABLES.Column_Title_ConstractionStarts': 'Start of Build',
    'TABLES.Column_Title_ConstractionEnds': 'End of Build',
    'TABLES.Column_Title_EventStarts': 'Event starts',
    'TABLES.Column_Title_Dismantling': 'Dismantling',
    'TABLES.Column_Title_ElfeOnline': 'Exhibition is online',
    'TABLES.Column_Title_TimeCompletion': 'deadline',
    'TABLES.Column_Title_Subcontractor': 'subcontractor',
    'TABLES.Column_Title_ID': 'ID',
    'TABLES.Column_Sorting_Tooltip_Ascending': 'Click to sort ascending',
    'TABLES.Column_Sorting_Tooltip_Descending': 'Click to sort descending',
    'TABLES.Column_Sorting_Tooltip_Cancel': 'Click to cancel sorting',
    'TABLES.Column_Title_FileName': 'file name',
    'TABLES.Column_Title_FurnishingDescription': 'Description',
    'TABLES.Column_Title_Sku': 'SKU',
    'TABLES.Column_Title_Image': 'Photo',
    'TABLES.Column_Title_LastMinutePrice': 'Last minute price',
    'TABLES.Column_Title_Quantity': 'Quantity',
    'TABLES.Column_Title_ShelfNumber': 'Shelf No.',
    'TABLES.Column_Title_Shelf': 'Shelf',
    'TABLES.Column_Title_ShelfUser': 'User',
    'TABLES.Column_Title_ShelfDate': 'Date',
    'TABLES.Column_Title_GraphicMiss': 'Status',
    'TABLES.Column_Title_Date': 'Date',
    'TABLES.Column_Title_PackedBy': 'Packed by',
    'TABLES.Column_Title_GraphicStandShelfNumber': 'Shelf No.',
    'TABLES.Column_Title_Outsourced': 'Pack',
    'TABLES.Column_Title_ReturnWarehouse': 'Return to Warehouse',
    'TABLES.Column_Title_Comment': 'Comment',
    'TABLES.Column_Title_GraphicAmount': 'Graphic Amount',
    'TABLES.Column_Title_GraphicStorage': 'Graphic Storage',
    'TABLES.Column_Title_Requests': 'Requests',
    'TABLES.Column_Title_Items': 'Processed items',
    'TABLES.Column_Title_PromptTokens': 'Input tokens',
    'TABLES.Column_Title_CompletionTokens': 'Output tokens',
    'TABLES.Column_Title_TotalTokens': 'Total tokens',
    'TABLES.Column_Title_TotalPrice': 'Total cost',
    'TABLES.Column_Title_Model': 'Model',
    'TABLES.Column_Title_SourceLanguage': 'Source language',
    'TABLES.Column_Title_TargetLanguage': 'Target language',
    'TABLES.Column_Title_LastRequest': 'Last request',
    'TABLES.Title_RequestBatchLog': 'Request log',
    'TABLES.Description_RequestBatchLog': 'Each row is one translation request batch for jobs or comments. UI label translations are excluded.',
    'TABLES.Value_FromCache': 'From cache',
    'TABLES.Value_Free': 'Free',
    'TABLES.Tooltip_Tokens': 'Input tokens plus output tokens used by job and comment translation requests.',
    'TABLES.Tooltip_Items': 'Total job and comment text items processed in translation requests.',
    'TABLES.Tooltip_Cost': 'Cost is based on provider pricing and token usage.',
    'TABLES.Tooltip_EstimatedCost': 'Estimated from token usage and model pricing.',
    'TABLES.Chart_Title_RequestsByDay': 'Requests by day',
    'TABLES.Chart_Title_TokenVolume': 'Token volume',
    'TABLES.Chart_Title_CostTrend': 'Cost trend',
    'TABLES.Chart_Title_RequestsByModel': 'Requests by model',
    'TABLES.Chart_Title_TargetLanguages': 'Target languages',
    'TABLES.Chart_Title_CostByModel': 'Cost by model',
    'TABLES.Chart_Description_RequestsByDay': 'Daily count of job and comment translation requests.',
    'TABLES.Chart_Description_TokenVolume': 'Input and output tokens used by job and comment translations.',
    'TABLES.Chart_Description_CostTrend': 'Job and comment translation cost over time.',
    'TABLES.Chart_Description_RequestsByModel': 'Job and comment translation requests grouped by AI model for the current filters.',
    'TABLES.Chart_Description_TargetLanguages': 'Shows up to 20 target languages for the current job and comment request results.',
    'TABLES.Chart_Description_CostByModel': 'Job and comment translation cost grouped by model for the current filters.',
    'FORM_RULES.Min_NewPassword': 'Password must be at least { minLength } characters',
    'FORM_RULES.Required_NewPassword': 'Please input new Password',
    'FORM_RULES.Required_ConfirmPassword': 'Please confirm new password',
    'FORM_RULES.Required_ConfirmPasswordMatch': 'The entered passworts do not match.',
    'FORM_RULES.Required_Name': 'Please input name',
    'FORM_RULES.Required_Surname': 'Please input surname',
    'FORM_RULES.Required_Email': 'The input is not valid E-mail',
    'FORM_RULES.Required_Choose': 'Please Choose',
    'FORM_RULES.Required_Phone': 'Please input phone',
    'FORM_RULES.Required_GroupName': 'Please input group name',
    'FORM_RULES.Required_LanguageLabel': 'Please input language label',
    'FORM_RULES.Required_LanguageSlug': 'Please input language slug',
    'FORM_RULES.Required_Title': 'Please input title',
    'FORM_RULES.Required_Number': 'Please input number',
    'FORM_RULES.Required_Where': 'Please choose where to change the time',
    'FORM_RULES.Required_DeliveryTime': 'Please Choose Delivery Time',
    'FORM_RULES.Required_Exhibitor': 'Please input Exhibitor Name',
    'FORM_RULES.Required_ProafNumber': 'Please input Proauf number',
    'FORM_RULES.Required_StandNumber': 'Please input stand number',
    'FORM_RULES.Required_CadNumber': 'Please input cad number',
    'FORM_RULES.Required_KeyName': 'Please input key name',
    'FORM_RULES.Required_KeyNumber': 'Please input key number',
    'FORM_RULES.Required_HallName': 'Please input hall name',
    'FORM_RULES.Required_HallNumber': 'Please input hall number',
    'FORM_RULES.Required_Password': 'Please input your Password!',
    'FORMS.Input_Label_FurnishingDescr': 'Description',
    'FORMS.Input_Label_Sku': 'SKU',
    'FORMS.Input_Label_LastMinutePrice': 'Last minute price',
    'FORMS.Input_Label_LastMinuteQuantity': 'Quantity',
    'FORMS.Input_Label_Password': 'Password',
    'FORMS.Input_Label_Login': 'login',
    'FORMS.Input_Label_NewPassword': 'New password',
    'FORMS.Input_Label_ConfirmPassword': 'Confirm new password',
    'FORMS.Input_Label_Language': 'Language',
    'FORMS.Input_Label_LanguageLabel': 'Language label',
    'FORMS.Input_Label_LanguageSlug': 'Language slug',
    'FORMS.Input_Label_Craft': 'craft',
    'FORMS.Input_Label_CraftType': 'craft type',
    'FORMS.Input_Label_CraftTitle': 'craft title',
    'FORMS.Input_Label_TimeOfCompletion': 'Deadline',
    'FORMS.Input_Label_Name': 'Name',
    'FORMS.Input_Label_Surname': 'Surname',
    'FORMS.Input_Label_Phone': 'Phone (login)',
    'FORMS.Input_Label_Email': 'Email',
    'FORMS.Input_Label_UsersGroup': 'Users Group',
    'FORMS.Input_Label_GroupName': 'Group Name',
    'FORMS.Input_Label_GroupColor': 'Group Color',
    'FORMS.Input_Label_CrmRights': 'CRM Rights',
    'FORMS.Input_Label_Attachment': 'Attachment',
    'FORMS.Input_Label_HallPlan': 'Hall plan',
    'FORMS.Input_Label_AppRights': 'ELFE APP Rights',
    'FORMS.Input_Label_Subcontractor': 'Subcontractor',
    'FORMS.Input_Label_AssignedExhibitions': 'assigned exhibitions',
    'FORMS.Input_Label_Title': 'title',
    'FORMS.Input_Label_Number': 'number',
    'FORMS.Input_Label_Where': 'Where',
    'FORMS.Input_Label_Hall': 'Hall',
    'FORMS.Input_Label_NewDeliveryTime': 'New Deadline',
    'FORMS.Input_Label_Exhibitor': 'Exhibitor Name',
    'FORMS.Input_Label_AcqstnNumber': 'Acquisition Number',
    'FORMS.Input_Label_ProaufNumber': 'Proauf number',
    'FORMS.Input_Label_Proauf': 'Proauf',
    'FORMS.Input_Label_Block': 'block',
    'FORMS.Input_Label_Corridor': 'corridor',
    'FORMS.Input_Label_Stand': 'stand',
    'FORMS.Input_Label_StandNum': 'stand №',
    'FORMS.Input_Label_StandNumber': 'stand number',
    'FORMS.Input_Label_CadNumber': 'cad number',
    'FORMS.Input_Label_Time': 'time',
    'FORMS.Input_Label_DeliveryTime': 'Deadline',
    'FORMS.Input_Label_Acquisition': 'acquisition',
    'FORMS.Input_Label_KeyName': 'key name',
    'FORMS.Input_Label_Key': 'key',
    'FORMS.Input_Label_JobType': 'job type',
    'FORMS.Input_Label_JobStatus': 'job status',
    'FORMS.Input_Label_JobNum': 'job №',
    'FORMS.Input_Label_Exhibition': 'exhibition',
    'FORMS.Input_Label_ExhibitionName': 'exhibition name',
    'FORMS.Input_Label_ExhibitionStarts': 'exhibition starts',
    'FORMS.Input_Label_ExhibitionEnds': 'exhibition ends',
    'FORMS.Input_Label_ElfeOnline': 'Exhibition is online',
    'FORMS.Input_Label_ConstructionStarts': 'construction starts',
    'FORMS.Input_Label_ConstructionEnds': 'construction ends',
    'FORMS.Input_Label_DismantlingStarts': 'Dismantling starts',
    'FORMS.Input_Label_DismantlingEnds': 'Dismantling ends',
    'FORMS.Input_Label_ExhibitionLink': 'exhibition link',
    'FORMS.Input_Label_ExhibitionEvent': 'Exhibition Event',
    'FORMS.Input_Label_Description': 'description',
    'FORMS.Input_Label_ChooseType': 'Choose type',
    'FORMS.Input_Label_Status': 'Status',
    'FORMS.Input_Label_ChooseStatus': 'Choose status',
    'FORMS.Input_Label_HallName': 'hall name',
    'FORMS.Input_Label_HallNumber': 'hall number',
    'FORMS.Input_Label_HallToMoveStandsTo': 'hall to move stands to',
    'FORMS.Input_Label_NewFinishingTime': 'New deadline',
    'FORMS.Input_Label_Company': 'company',
    'FORMS.Input_Label_ShelfNumber': 'shelf no.',
    'FORMS.Input_Label_GraphicStandShelfNumber': 'shelf no.',
    'FORMS.Input_Label_CompletedAt': 'Completed at',
    'FORMS.Input_Label_CraftTypeIcon': 'Craft icon',
    'FORMS.Input_Label_CraftCustomIcon': 'Custom icon',
    'FORMS.Input_Label_Model': 'Model',
    'FORMS.Input_Label_SourceLanguage': 'Source language',
    'FORMS.Input_Label_TargetLanguage': 'Target language',
    'FORMS.Input_Label_CheckLatitude': 'Latitude',
    'FORMS.Input_Label_CheckLongitude': 'Longitude',
    'FORMS.Input_Label_CheckRadius': 'Radius in meters',
    'FORMS.Validation_CheckRadiusRange': 'Radius must be between 1 and 75 meters.',
    'FORMS.Input_Label_CheckLocationCountry': 'Country',
    'FORMS.Input_Label_CheckLocationSearch': 'Address or venue',
    'FORMS.Title_ChangePassword': 'Change password',
    'FORMS.Title_SendPassword': 'Send password',
    'FORMS.Title_AddUsers': 'Add users',
    'FORMS.Title_SelectStand': 'Select stand',
    'FORMS.Title_CopyFromEvent': 'Copy from event',
    'MODAL.Button_Text_CopyFromEvent': 'Copy from event',
    'FORMS.Title_AddSubcontractor': 'Add subcontractor',
    'FORMS.Title_AssignSubcontractors': 'Assign subcontractors',
    'FORMS.Title_ChooseSubcontractor': 'Choose subcontractor',
    'FORMS.Title_ChooseType': 'Choose type',
    'FORMS.Title_AddExhibitions': 'Add exhibitions',
    'FORMS.Title_DeliveryTime': 'Change deadline',
    'FORMS.Title_CraftTime': 'Change craft deadline',
    'FORMS.Title_CraftDone': 'Craft done',
    'FORMS.Title_CraftInProcess': 'Craft in process',
    'FORMS.Title_CraftAdditional': 'Create additional craft',
    'FORMS.Title_CraftAdditionalEdit': 'Edit additional craft',
    'FORMS.Title_CraftDelete': 'Delete craft',
    'FORMS.Title_CreateLastMinJob': 'Create last minute job',
    'FORMS.Title_DeleteHall': 'Delete hall',
    'FORMS.Title_EditJob': 'Edit job',
    'FORMS.Title_EditFurnishing': 'Edit Furnishing',
    'FORMS.Title_AddFurnishing': 'Add Furnishing',
    'FORMS.Title_EditCraft': 'Edit craft',
    'FORMS.Title_CreateCraft': 'Create craft',
    'FORMS.Title_Text_Filters': 'Filters',
    'FORMS.Title_Text_CreateJob': 'Create job',
    'FORMS.Title_AddFile': 'Add file',
    'FORMS.Title_EditFile': 'Edit file',
    'FORMS.Title_AddPrint': 'Add print',
    'FORMS.Title_AddComment': 'Add comment',
    'FORMS.Title_EditComment': 'Edit comment',
    'FORMS.Title_SelectGraphicStand': 'Select Exhibitor',
    'FORMS.Title_ChooseShelf': 'Choose free shelf',
    'FORMS.Select_OptionLabel_English': 'English',
    'FORMS.Select_OptionLabel_Deutsch': 'Deutsch',
    'FORMS.Select_OptionLabel_ChooseColor': 'Choose Color',
    'FORMS.Select_OptionLabel_SelectedStands': 'In the selected stands ({ length })',
    'FORMS.Select_OptionLabel_AllStandsHall': 'In all stands in the hall',
    'FORMS.Select_OptionLabel_AllStandsExhibition': 'In all stands in the exhibition',
    'FORMS.Select_OptionLabel_HallNotSelected': 'Hall not selected',
    'FORMS.Select_OptionLabel_Completed': 'Completed',
    'FORMS.Select_OptionLabel_InProgress': 'In Progress',
    'FORMS.Radio_Label_Company': 'Company',
    'FORMS.Radio_Label_Subcontractor': 'Subcontractor',
    'FORMS.Radio_Label_ChoosenCraft': 'Choosen Craft',
    'FORMS.Radio_Label_AllCrafts': 'All Crafts',
    'FORMS.Checkbox_Label_JobCompleted': 'job is completed',
    'FORMS.Checkbox_Label_CraftCompleted': 'craft is completed',
    'FORMS.Input_Placeholder_Email': 'Email',
    'FORMS.Input_Placeholder_Password': 'Password',
    'FORMS.Input_Placeholder_Choose': 'Please Choose',
    'FORMS.Input_Placeholder_LanguageLabel': 'Enter language label',
    'FORMS.Input_Placeholder_LanguageSlug': 'Enter language slug',
    'FORMS.Input_Placeholder_GroupName': 'Please input group name',
    'FORMS.Input_Placeholder_ChooseColor': 'Choose Color',
    'FORMS.Input_Placeholder_Where': 'Please choose where to change the time',
    'FORMS.Input_Placeholder_ChooseHall': 'Choose a hall',
    'FORMS.Input_Placeholder_ChooseExhibition': 'Choose an exhibition',
    'FORMS.Input_Placeholder_ChooseStand': 'Choose a stand',
    'FORMS.Input_Placeholder_DeliveryTime': 'Choose deadline',
    'FORMS.Input_Placeholder_AcqstnNumber': 'Enter acquisition number',
    'FORMS.Input_Placeholder_ProaufNumber': 'Enter proauf number',
    'FORMS.Input_Placeholder_CorridorNumber': 'Corridor number',
    'FORMS.Input_Placeholder_BlockNumber': 'Block number',
    'FORMS.Input_Placeholder_StandNumber': 'Stand number',
    'FORMS.Input_Placeholder_ShelfNumber': 'Shelf number',
    'FORMS.Input_Placeholder_CadNumber': 'Cad number',
    'FORMS.Input_Placeholder_ShortDescription': 'Enter short description',
    'FORMS.Input_Placeholder_ChooseStatus': 'Choose status',
    'FORMS.Input_Placeholder_ChooseType': 'Choose type',
    'FORMS.Input_Placeholder_ChooseCraftType': 'Choose craft type',
    'FORMS.Input_Placeholder_ExhibitionName': 'Please input exhibition name',
    'FORMS.Input_Placeholder_ExhibitionEvent': 'Enter exhibition event name',
    'FORMS.Input_Placeholder_HallName': 'Please input hall name',
    'FORMS.Input_Placeholder_CraftCompletion': 'Please choose craft deadline',
    'FORMS.Input_Placeholder_SelectDate': 'Select date',
    'FORMS.Input_Placeholder_StartDate': 'Start date',
    'FORMS.Input_Placeholder_EndDate': 'End date',
    'FORMS.Input_Placeholder_Company': 'Company',
    'FORMS.Input_Placeholder_SelectStand': 'Exhibitor search',
    'FORMS.Input_Placeholder_SelectGraphicStand': 'Select graphic stand',
    'FORMS.Input_Placeholder_CompletedAt': 'Completed at',
    'FORMS.Input_Placeholder_Exhibitor': 'Exhibitor Name',
    'FORMS.Input_Placeholder_CustomShelf': 'Enter custom shelf',
    'FORMS.Validation_DismantlingDatesRequiredTogether': 'Enter both dismantling dates or leave both empty.',
    'FORMS.Validation_DismantlingEndBeforeStart': 'Dismantling end cannot be before dismantling start.',
    'SEARCH.Input_Placeholder_User': 'Search for users',
    'SEARCH.Input_Placeholder_Table_User': 'Search for name, email, phone',
    'SEARCH.Input_Placeholder_Subcontractor': 'Search for subcontractor',
    'SEARCH.Input_Placeholder_Table_Subcontractor': 'Search for ID, title, number',
    'SEARCH.Input_Placeholder_Languages': 'Search languages',
    'SEARCH.Input_Placeholder_Exhibition': 'Search for exhibitions',
    'SEARCH.Input_Placeholder_Stand': 'Search for stand',
    'SEARCH.Input_Placeholder_Table_Stand': 'Search stand',
    'SEARCH.Input_Placeholder_GlobalStand': 'Search stand',
    'SEARCH.Input_Placeholder_Table_SearchKeyWords': 'Search for key words',
    'SEARCH.Input_Placeholder_MultiSelect': 'Search',
    'SEARCH.Input_Placeholder_GraphicStands': 'Exhibitor search',
    'SEARCH.Input_Placeholder_WarehouseShelves': 'Shelf or exhibitor search',
    'SEARCH.Input_Placeholder_FreeShelves': 'Search free shelf',
    'SEARCH.Input_Placeholder_TranslationAiUsage': 'Search job and comment translation usage',
    'SEARCH.Input_Placeholder_TranslationAiRequests': 'Search job and comment translation requests',
    'SEARCH.Input_Placeholder_CheckLocation': 'Enter an address or exhibition venue',
    'SEARCH.Empty_CheckLocation': 'No matching addresses or venues found',
    'SEARCH.Error_CheckLocationUnavailable': 'Search is temporarily unavailable. Use the map manually.',
    'SEARCH.Error_CheckLocationRateLimit': 'Search limit reached. Use the map manually or try again later.',
    'ACTIONS.List_Item_Label_StandPlan': 'Stand drawing',
    'ACTIONS.List_Item_Label_Graphic': 'graphic',
    'ACTIONS.List_Item_Label_Photo': 'photo',
    'ACTIONS.List_Item_Label_Info': 'Info',
    'ACTIONS.List_Item_Label_HallPlan': 'hall plan',
    'ACTIONS.List_Item_Label_Image': 'photo',
    'ACTIONS.List_Item_Label_ShowQRCode': 'Show QR Code',
    'ACTIONS.List_Item_Label_PrintLabel': 'Print Label',
    'ACTIONS.List_Item_Label_Collected': 'Collected but not verified',
    'ACTIONS.List_Item_Label_Open': 'Open',
    'ACTIONS.List_Item_Label_Done': 'Verified and stored',
    'ACTIONS.List_Item_Label_Sent': 'Collected and sent',
    'ACTIONS.Creating': 'Creating...',
    'ACTIONS.Create_Graphic_Stand': 'Create Graphic Stand',
    'ACTIONS.Fill_All_Fields': 'Fill all fields first',
    'ACTIONS.Create': 'Create',
    'ACTIONS.Return_To_Warehouse': 'Return to warehouse',
    'GLOBAL.Button_Text_Save': 'Save',
    'GLOBAL.Button_Text_Send': 'Send',
    'GLOBAL.Button_Text_SaveSend': 'Save and send',
    'GLOBAL.Button_Text_SaveChanges': 'Save changes',
    'GLOBAL.Button_Text_UserToGroup': 'Add user to group',
    'GLOBAL.Button_Text_Update': 'update',
    'GLOBAL.Button_Text_Reimport': 'reimport',
    'GLOBAL.Button_Text_Cancel': 'Cancel',
    'GLOBAL.Button_Text_Delete': 'Delete',
    'GLOBAL.Button_Text_Remove': 'Remove',
    'GLOBAL.Button_Text_Confirm': 'Confirm',
    'GLOBAL.Button_Text_AddFile': 'Add file',
    'GLOBAL.Button_Text_UploadFile': 'Upload file',
    'GLOBAL.Button_Text_UserGroup': 'User group',
    'GLOBAL.Button_Text_Login': 'Login',
    'GLOBAL.Button_Text_BackHome': 'Back Home',
    'GLOBAL.Modal_Text_UserSendPass': 'Are you sure you want to send a{ br }new password?',
    'GLOBAL.Modal_Text_RemoveText': 'Are you sure you want to remove the { deleteObjectType }?',
    'GLOBAL.Modal_Text_DeleteText': 'Are you sure you want to delete the { deleteObjectType }?',
    'GLOBAL.Modal_Text_RemoveFrom': 'from the',
    'GLOBAL.Modal_Text_DeleteHallStands': 'You want to delete a hall that contains stands. Please choose another hall to move stands to',
    'GLOBAL.Modal_Text_DeleteHall': 'Are you sure you want to delete the hall',
    'GLOBAL.Modal_Text_ResetFilters': 'Reset filters',
    'GLOBAL.Button_Text_ExportCsv': 'export',
    'GLOBAL.Button_Text_ExportExel': 'export excel',
    'GLOBAL.Button_Text_SubcontractorsFile': 'The subcontractors file is importing',
    'GLOBAL.Button_Text_DownloadReport': 'download report',
    'GLOBAL.Button_Text_Actions': 'Actions',
    'GLOBAL.Button_Text_ImportGraphicList': 'Import Graphic List',
    'GLOBAL.Button_Text_CreatePacking': 'Create packing',
    'GLOBAL.Button_Text_BackExhibitionList': 'Back to exhibition list',
    'GLOBAL.Button_Text_GoToGraphicPackingStands': 'Go to packed graphic list',
    'GLOBAL.Button_Text_BackGraphicChoise': 'Back to graphic choice',
    'GLOBAL.Button_Text_AvailableStoredGraphics': 'Available stored graphics export excel',
    'GLOBAL.Button_Text_EverStoredGraphics': 'Ever stored graphics export excel',
    'CHECK_QR.Button_Generate': 'CHECK-IN QR',
    'CHECK_QR.Button_View': 'CHECK-IN QR',
    'CHECK_QR.Button_Update': 'UPDATE CHECK-IN QR',
    'CHECK_QR.Button_Create': 'GENERATE QR CODE',
    'CHECK_QR.Button_Regenerate': 'REGENERATE QR CODE',
    'CHECK_QR.Confirm_RegenerateTitle': 'Regenerate check-in QR code?',
    'CHECK_QR.Confirm_RegenerateText': 'Warning! The current printed QR code will stop working. All employees will need to scan the new code. Continue?',
    'CHECK_QR.Button_Retry': 'RETRY QR GENERATION',
    'CHECK_QR.Tooltip_FillCoordinates': 'Save valid check-in coordinates first.',
    'CHECK_QR.Modal_Title': 'Exhibition Check-in QR',
    'CHECK_QR.Button_DownloadPng': 'Download PNG',
    'CHECK_QR.Button_DownloadPdf': 'Download PDF',
    'CHECK_QR.Button_Print': 'Print',
    'CHECK_QR.Text_GeneratedAt': 'QR Code generated: { date }',
    'CHECK_QR.Text_GenerationDateNotRecorded': 'QR generation date not recorded',
    'CHECK_QR.Text_PositionUpdatedAt': 'Location updated: { date }',
    'CHECK_QR.LocationInfo_Label': 'QR code validity after location changes',
    'CHECK_QR.LocationInfo_Hint': 'Changing coordinates or radius keeps the printed QR code valid. No regeneration is required.',
    'CHECK_QR.Text_DateUnavailable': 'Date unavailable',
    'CHECK_QR.Text_NoQrUrl': 'The QR code could not be created. Try again.',
    'CHECK_QR.Text_PdfError': 'Could not generate PDF',
    'CHECK_QR.Text_ExportError': 'Could not create QR poster',
    'GLOBAL.Link_Text_Download': 'Download',
    'GLOBAL.Link_Text_Unassigned': 'unassigned',
    'GLOBAL.Link_Text_Assigned': 'Assigned',
    'GLOBAL.Text_NoData': 'No Data',
    'GLOBAL.Text_Status_Active': 'Active',
    'GLOBAL.Text_Status_Disabled': 'Disabled',
    'GLOBAL.Text_Status_InProgress': 'In progress',
    'GLOBAL.Text_Status_Completed': 'Completed',
    'GLOBAL.Text_Status_Overdue': 'Overdue',
    'GLOBAL.Text_Status_ChangePassUser': 'Password sent by { user } at { dateTime }',
    'GLOBAL.Text_NoAdditionalCrafts': 'There is no additional craft for the selected stands',
    'GLOBAL.Text_GraphicCount': 'amount stands',
    'WAREHOUSE.Label_AmountShelves': 'Amount Shelves',
    'WAREHOUSE.Label_Occupied': 'Occupied',
    'WAREHOUSE.Label_Empty': 'Empty',
    'WAREHOUSE.Label_FreeShelves': 'Free shelves',
    'WAREHOUSE.Label_CustomShelf': 'Custom shelf',
    'WAREHOUSE.Label_CurrentShelf': 'Current shelf',
    'WAREHOUSE.Button_Text_ResetShelf': 'Reset shelf',
    'WAREHOUSE.Button_Text_ResetShelfValue': 'Reset shelf { shelfNumber }',
    'WAREHOUSE.Text_NoFreeShelves': 'No free shelves found',
    'WAREHOUSE.Text_CustomShelfRequired': 'Enter a shelf number.',
    'WAREHOUSE.Text_CustomShelfOccupied': 'This shelf is already occupied.',
    'MODAL.Button_Text_Choose': 'Choose',
    'MODAL.Button_Text_AddExhibition': 'Add Exhibition',
    'MODAL.Button_Text_Stands': 'Stands',
    'MODAL.Button_Text_Crafts': 'Crafts',
    'MODAL.Button_Text_DeliveryTime': 'Change deadline',
    'MODAL.Button_Text_CraftTime': 'Change craft deadline',
    'MODAL.Button_Text_AssignSubcontractors': 'Assign subcontractors',
    'MODAL.Button_Text_CraftDone': 'Craft done',
    'MODAL.Button_Text_CraftInProcess': 'Craft in process',
    'MODAL.Button_Text_CraftAdditional': 'Create additional craft',
    'MODAL.Button_Text_CraftAdditionalEdit': 'Edit additional craft',
    'MODAL.Button_Text_CraftDelete': 'Delete craft',
    'MODAL.Button_Text_JobCreate': 'Create Job',
    'MODAL.Button_Text_AddUserEvent': 'Add user to event',
    'MODAL.Button_Text_AddPrint': 'Add print',
    'FORMS.Button_Text_ApplyFilters': 'Apply filters',
    'FORMS.Button_Text_ResetFilters': 'Reset filters',
    'FORMS.Button_Text_AddKey': 'Add new key',
    'ENTITY.Modal_Title_User': 'user',
    'ENTITY.Modal_Title_Group': 'group',
    'ENTITY.Modal_Title_Language': 'language',
    'ENTITY.Modal_Title_ExhibitionStand': 'exhibition stand',
    'ENTITY.Modal_Title_ExhibitionEvent': 'exhibition event',
    'ENTITY.Modal_Title_Exhibition': 'exhibition',
    'ENTITY.Modal_Title_Subcontractor': 'subcontractor',
    'ENTITY.Modal_Title_StandKey': 'stand key',
    'ENTITY.Modal_Title_Stand': 'stand',
    'ENTITY.Modal_Title_Craft': 'craft',
    'ENTITY.Modal_Title_Job': 'job',
    'ENTITY.Modal_Title_Furnishing': 'Furnishing',
    'ENTITY.Modal_Title_Document': 'document',
    'ENTITY.Modal_Title_Downloading': 'Wait is downloading the file...',
    'ENTITY.Modal_Title_Importing': 'The event file is importing...',
    'ENTITY.Modal_Title_Imported': 'The event file has been imported:',
    'MENUS.Label_Exhibitions': 'exhibitions',
    'MENUS.Label_GlobalStandSearch': 'Global Stand Search',
    'MENUS.Label_Users': 'users',
    'MENUS.Label_Subcontractors': 'subcontractors',
    'MENUS.Label_StaffManagement': 'staff management',
    'MENUS.Label_LastMin': 'last minute',
    'MENUS.Label_GraphicStorage': 'graphics storage',
    'MENUS.Label_GraphicStore': 'graphic archive',
    'MENUS.Label_GraphicHandout': 'graphics hand out',
    'MENUS.Label_GraphicExhibition': 'Graphic Storage',
    'MENUS.Label_GraphicPackings': 'Graphic Packings',
    'MENUS.Label_GraphicWarehouse': 'Graphic Warehouse',
    'MENUS.Label_GraphicWarehouseOverview': 'Warehouse Overview',
    'MENUS.Label_ShelfUtilization': 'Shelf utilization',
    'MENUS.Label_Settings': 'Settings',
    'MENUS.Label_Languages': 'Languages',
    'MENUS.Label_TranslationAiUsage': 'Job & Comment AI Usage',
    'MENUS.Label_TranslationAiRequests': 'Job & Comment AI Requests',
    'MENUS_DROP.Label_MyProfile': 'My user account',
    'MENUS_DROP.Label_Logout': 'Logout',
    'MENUS_DROP.Label_Edit': 'Edit',
    'MENUS_DROP.Label_ViewLogs': 'View logs',
    'MENUS_DROP.Label_ViewKeys': 'View keys',
    'MENUS_DROP.Label_SendPass': 'Send password',
    'MENUS_DROP.Label_Delete': 'Delete',
    'MENUS_DROP.Label_Mark': 'Mark',
    'MENUS_DROP.Label_InProgress': 'in progress',
    'MENUS_DROP.Label_Open': 'open',
    'MENUS_DROP.Label_Done': 'done',
    'MENUS_DROP.Label_Make': 'Make',
    'MENUS_DROP.Label_Online': 'online',
    'MENUS_DROP.Label_Offline': 'offline',
    'MENUS_DROP.Label_UploadHallPlan': 'Upload hall plan',
    'MENUS_DROP.Label_LastMinReport': 'Last Minute report',
    'MENUS_DROP.Label_LastMinOrders': 'Last Minutes orders',
    'MENUS_DROP.Label_ComplainsReport': 'MP Claims report',
    'MENUS_DROP.Label_ExhibitorReport': 'Exhibitor Claim',
    'MENUS_DROP.Label_DamageReport': 'Damage report',
    'MENUS_DROP.Label_DamageReportAll': 'Damage report all',
    'MENUS_DROP.Label_ElfeOnline': 'Make online in ELFE',
    'MENUS_DROP.Label_ElfeOffline': 'Make offline in ELFE',
    'MENUS_DROP.Label_StandsQrCode': 'Stand Qrcodes',
    'MENUS_DROP.Label_StandsCommentsReport': 'Comments report',
    'NAVBAR_PAGES.Label_Overview': 'overview',
    'NAVBAR_PAGES.Label_Logs': 'logs',
    'NAVBAR_PAGES.Label_Users': 'users',
    'NAVBAR_PAGES.Label_UserGroups': 'user groups',
    'NAVBAR_PAGES.Label_GroupUsers': 'group users',
    'NAVBAR_PAGES.Label_Crafts': 'crafts',
    'NAVBAR_PAGES.Label_Jobs': 'jobs',
    'NAVBAR_PAGES.Label_Keys': 'keys',
    'NAVBAR_PAGES.Label_Stands': 'stands',
    'NAVBAR_PAGES.Label_Halls': 'halls',
    'NAVBAR_PAGES.Label_Documents': 'documents',
    'NAVBAR_PAGES.Label_Furnishings': 'Furnishings',
    'NAVBAR_PAGES.Label_GraphicStorage': 'graphic storage',
    'NAVBAR_PAGES.Label_Comments': 'comments',
    'NAVBAR_PAGES.Label_GraphicChoises': 'Graphic Choise',
    'NAVBAR_PAGES.Label_GraphicPackedList': 'Packed graphic list',
    'BREADCRUMBS.Label_Logs': 'logs',
    'BREADCRUMBS.Label_User': 'user',
    'BREADCRUMBS.Label_Users': 'users',
    'BREADCRUMBS.Label_UserGroups': 'user groups',
    'BREADCRUMBS.Label_GroupUsers': 'group users',
    'BREADCRUMBS.Label_Crafts': 'crafts',
    'BREADCRUMBS.Label_Jobs': 'jobs',
    'BREADCRUMBS.Label_Keys': 'keys',
    'BREADCRUMBS.Label_Stands': 'stands',
    'BREADCRUMBS.Label_Halls': 'halls',
    'BREADCRUMBS.Label_Exhibitions': 'exhibitions',
    'BREADCRUMBS.Label_GlobalStandSearch': 'Global Stand Search',
    'BREADCRUMBS.Label_Furnishings': 'Furnishing',
    'BREADCRUMBS.Label_Subcontractors': 'subcontractors',
    'BREADCRUMBS.Label_StaffManagement': 'staff management',
    'BREADCRUMBS.Label_LastMin': 'last minute',
    'BREADCRUMBS.Label_Create': 'create',
    'BREADCRUMBS.Label_Documents': 'documents',
    'BREADCRUMBS.Label_Graphic_Commissioning': 'Exhibition Graphic Packings',
    'BREADCRUMBS.Label_GraphicChoise': 'Graphic Choise',
    'BREADCRUMBS.Label_GraphicPackedList': 'Packed graphic list',
    'BREADCRUMBS.Label_GraphicStorage': 'graphic storage',
    'BREADCRUMBS.Label_GraphicWarehouseOverview': 'Warehouse Overview',
    'BREADCRUMBS.Label_ShelfUtilization': 'Shelf utilization',
    'BREADCRUMBS.Label_Comments': 'comments',
    'BREADCRUMBS.Label_Settings': 'settings',
    'BREADCRUMBS.Label_Languages': 'languages',
    'BREADCRUMBS.Label_TranslationAiUsage': 'job & comment translation usage',
    'BREADCRUMBS.Label_TranslationAiRequests': 'job & comment translation requests',
    'COMMENTS.Button_Text_Add': 'Add comment',
    'COMMENTS.Button_Text_AddUpper': 'ADD COMMENT',
    'COMMENTS.Button_Text_Save': 'SAVE',
    'COMMENTS.Button_Text_Export': 'EXPORT TO FILE',
    'COMMENTS.Text_NoComments': 'There are no comments yet',
    'COMMENTS.Text_Uploading': 'Uploading...',
    'PAGES.Title_Dashboard': 'Dashboard',
    'PAGES.Title_Users': 'Users',
    'PAGES.Title_CreateUser': 'Create User',
    'PAGES.Title_CreateGroupUser': 'Create User Group',
    'PAGES.Title_UserGroups': 'User Groups',
    'PAGES.Title_Languages': 'Languages',
    'PAGES.Title_CreateLanguage': 'Create Language',
    'PAGES.Title_EditLanguage': 'Edit Language',
    'PAGES.Title_Subcontractors': 'Subcontractors',
    'PAGES.Title_StaffManagement': 'Staff Management',
    'PAGES.Title_SubcontractorCreate': 'Create Subcontractor',
    'PAGES.Title_CreateStand': 'Create Stand',
    'PAGES.Title_LastMinJobs': 'Last minute jobs',
    'PAGES.Title_CreateHall': 'Create Hall',
    'PAGES.Title_Exhibitions': 'Exhibitions',
    'PAGES.Title_GlobalStandSearch': 'Global Stand Search',
    'PAGES.Title_CreateExhibitions': 'Create Exhibition',
    'PAGES.Title_CreateExhibitionPacking': 'Create new exhibition packing',
    'PAGES.Title_GraphicCommissioning': 'Exhibition Graphic Packings',
    'PAGES.Title_CreateGraphicStand': 'Create Graphic-Provide',
    'PAGES.Title_ShelfUtilization': 'Shelf utilization',
    'PAGES.Title_TranslationAiUsage': 'Job & Comment Translation Usage',
    'PAGES.Title_TranslationAiRequests': 'Job & Comment Translation Requests',
    'PAGES.Text_AllExisting': 'ALL existing last minute jobs in the stand',
    'PAGES.Text_NoExisting': 'There is no existing last minute jobs in the stand',
    'PAGES.Text_404': 'Sorry, the page you visited does not exist.',
    'CRAFTS.label_Logistics': 'logistics { num }',
    'CRAFTS.label_Floor': 'floor { num }',
    'CRAFTS.label_Assembly': 'assembly { num }',
    'CRAFTS.label_Electrics': 'electrics { num }',
    'CRAFTS.label_Graphic': 'graphic { num }',
    'CRAFTS.label_Furniture': 'furniture { num }',
    'CRAFTS.label_Multimedia': 'multimedia { num }',
    'CRAFTS.label_Cleaning': 'cleaning { num }',
    'CRAFTS.label_Additional': 'additional { num }',
    'CRAFTS.label_MpControl': 'mp control',
    'CRAFTS.label_Protocol': 'protocol',
    'CRAFTS.label_Service': 'service { num }',
    'CRAFTS.label_CollectGraphics': 'collect graphics { num }',
    'NOTIFICATIONS.GraphicStandCreated': 'Graphic Stand Created',
    'NOTIFICATIONS.GraphicStandCreatedDescription': 'Graphic stand take from warehouse has been successfully',
    'STAFF_MANAGEMENT.Column_Exhibition': 'Exhibition',
    'STAFF_MANAGEMENT.Column_Status': 'Status',
    'STAFF_MANAGEMENT.Column_Construction': 'Construction',
    'STAFF_MANAGEMENT.Column_ExhibitionPeriod': 'Exhibition',
    'STAFF_MANAGEMENT.Column_Dismantling': 'Dismantling',
    'STAFF_MANAGEMENT.Column_Workers': 'Workers',
    'STAFF_MANAGEMENT.Column_Subcontractors': 'Subcontractors',
    'STAFF_MANAGEMENT.Filter_SearchExhibition': 'Search for exhibition',
    'STAFF_MANAGEMENT.Filter_AllStatuses': 'All statuses',
    'STAFF_MANAGEMENT.Filter_ConstructionPeriod': 'Construction period',
    'STAFF_MANAGEMENT.Filter_ExhibitionPeriod': 'Exhibition period',
    'STAFF_MANAGEMENT.Filter_DismantlingPeriod': 'Dismantling period',
    'STAFF_MANAGEMENT.Status_live': 'Live',
    'STAFF_MANAGEMENT.Status_construction': 'Construction',
    'STAFF_MANAGEMENT.Status_upcoming': 'Upcoming',
    'STAFF_MANAGEMENT.Status_ready_dismantling': 'Awaiting dismantling',
    'STAFF_MANAGEMENT.Status_dismantling': 'Dismantling in progress',
    'STAFF_MANAGEMENT.Status_past': 'Past',
    'STAFF_MANAGEMENT.Status_unknown': 'Unknown',
    'STAFF_MANAGEMENT.Text_OnSite': 'on site',
    'STAFF_MANAGEMENT.Workers_MissedCheckoutOne': '{ count } worker did not check out in time',
    'STAFF_MANAGEMENT.Workers_MissedCheckoutMany': '{ count } workers did not check out in time',
    'STAFF_MANAGEMENT.Workers_FailedCheckoutOne': 'Checkout rejected by the system for { count } worker',
    'STAFF_MANAGEMENT.Workers_FailedCheckoutMany': 'Checkout rejected by the system for { count } workers',
    'STAFF_MANAGEMENT.Workers_StatusesLoading': 'Loading worker statuses',
    'STAFF_MANAGEMENT.Workers_StatusesUnavailable': 'Statuses unavailable',
    'STAFF_MANAGEMENT.Text_Subcontractors': 'subcontractors',
    'STAFF_MANAGEMENT.Action_CheckInQr': 'Check-in QR',
    'STAFF_MANAGEMENT.Action_NoQr': 'No QR code yet',
    'STAFF_MANAGEMENT.Action_GenerateQr': 'Generate QR code',
    'STAFF_MANAGEMENT.Action_RegenerateQr': 'Regenerate QR',
    'STAFF_MANAGEMENT.Text_RevokeQrPrompt': 'Need to revoke this code?',
    'STAFF_MANAGEMENT.Action_RetryQrGeneration': 'Retry QR',
    'STAFF_MANAGEMENT.Action_ClearAll': 'Clear all',
    'STAFF_MANAGEMENT.Action_Retry': 'Retry',
    'STAFF_MANAGEMENT.Action_AddGroup': 'Add group',
    'STAFF_MANAGEMENT.Tab_CheckInSetup': 'Check-in setup',
    'STAFF_MANAGEMENT.Tab_CheckInHistory': 'Check-in Position History',
    'STAFF_MANAGEMENT.History_Description': 'Shows who changed this exhibition’s check-in coordinates, radius, country or address, when they changed them, the source (App or CRM), and the previous and new values.',
    'STAFF_MANAGEMENT.History_LoadError': 'Check-in position history could not be loaded.',
    'STAFF_MANAGEMENT.History_Retry': 'Retry',
    'STAFF_MANAGEMENT.History_ChangedBy': 'Changed by',
    'STAFF_MANAGEMENT.History_Source': 'Source',
    'STAFF_MANAGEMENT.History_DateTime': 'Date and time',
    'STAFF_MANAGEMENT.History_ChangedFields': 'Changed fields',
    'STAFF_MANAGEMENT.History_NewPosition': 'New position and radius',
    'STAFF_MANAGEMENT.History_Details': 'Details',
    'STAFF_MANAGEMENT.History_DetailsTitle': 'Check-in position change',
    'STAFF_MANAGEMENT.History_Field': 'Field',
    'STAFF_MANAGEMENT.History_Before': 'Before',
    'STAFF_MANAGEMENT.History_After': 'After',
    'STAFF_MANAGEMENT.History_Latitude': 'Latitude',
    'STAFF_MANAGEMENT.History_Longitude': 'Longitude',
    'STAFF_MANAGEMENT.History_Radius': 'Radius',
    'STAFF_MANAGEMENT.History_Country': 'Country',
    'STAFF_MANAGEMENT.History_Address': 'Address',
    'STAFF_MANAGEMENT.History_QrGeneratedAt': 'QR generation',
    'STAFF_MANAGEMENT.History_NoPosition': 'No position was recorded for this change.',
    'STAFF_MANAGEMENT.Tab_Workers': 'Workers',
    'STAFF_MANAGEMENT.Tab_Attendance': 'Attendance',
    'STAFF_MANAGEMENT.Tab_AuditLog': 'Audit log',
    'STAFF_MANAGEMENT.Action_AttendanceReport': 'Attendance report',
    'STAFF_MANAGEMENT.Action_AuditLogReport': 'Audit log report',
    'STAFF_MANAGEMENT.Section_CheckInLocation': 'Check-in location',
    'STAFF_MANAGEMENT.Provenance_LastSet': 'Last set:',
    'STAFF_MANAGEMENT.Provenance_Created': 'Created:',
    'STAFF_MANAGEMENT.Provenance_By': 'by { name }',
    'STAFF_MANAGEMENT.Provenance_FromApp': 'from app',
    'STAFF_MANAGEMENT.Provenance_FromCrm': 'from crm',
    'STAFF_MANAGEMENT.Provenance_Unavailable': 'Not available',
    'STAFF_MANAGEMENT.Section_SetUpCheckIn': 'Set up check-in',
    'STAFF_MANAGEMENT.Step_ChooseGroups': '1. Choose the user groups that need to check in',
    'STAFF_MANAGEMENT.Step_SetUpLocation': '2. Set up the check-in location & zone',
    'STAFF_MANAGEMENT.Modal_ChooseGroups': 'Choose the user groups that need to check in',
    'STAFF_MANAGEMENT.Section_CheckInQr': 'Check-in QR code',
    'STAFF_MANAGEMENT.Field_Address': 'Address',
    'STAFF_MANAGEMENT.Placeholder_Address': 'Enter address or name of the venue',
    'STAFF_MANAGEMENT.Text_DragPin': 'You can drag the pin on the map — the fields update automatically.',
    'STAFF_MANAGEMENT.Text_QrDescription': 'Workers scan this QR code at the exhibition location. A check-in only counts when they are inside the allocated zone.',
    'STAFF_MANAGEMENT.QrState_Generating': 'Creating QR code…',
    'STAFF_MANAGEMENT.QrState_Regenerating': 'Creating a new QR code…',
    'STAFF_MANAGEMENT.QrState_GenerationFailed': 'Location saved, but the QR code could not be generated.',
    'STAFF_MANAGEMENT.QrState_RegenerationFailed': 'The new QR code could not be created. Try again.',
    'STAFF_MANAGEMENT.QrState_Outdated': 'Check-in location changed. Regenerate the QR code before using it.',
    'STAFF_MANAGEMENT.QrState_OutdatedLabel': 'Outdated',
    'STAFF_MANAGEMENT.QrState_SaveValidLocation': 'Save a valid check-in location before regenerating.',
    'STAFF_MANAGEMENT.QrState_SaveValidSetup': 'Save a valid location and at least one user group before regenerating.',
    'STAFF_MANAGEMENT.QrState_NoQrTitle': 'No QR yet',
    'STAFF_MANAGEMENT.QrState_NoQrDescription': 'Choose a user group and location, then press Save — { br }the code will appear here to download or print.',
    'STAFF_MANAGEMENT.Modal_CheckInQr': 'Check-in QR code',
    'STAFF_MANAGEMENT.Filter_SearchName': 'Search for name',
    'STAFF_MANAGEMENT.Filter_SearchWorker': 'Search for worker',
    'STAFF_MANAGEMENT.Filter_SelectPeriod': 'Select period',
    'STAFF_MANAGEMENT.Filter_Subcontractor': 'Subcontractor',
    'STAFF_MANAGEMENT.Filter_AllSubcontractors': 'All subcontractors',
    'STAFF_MANAGEMENT.Filter_GroupBy': 'Group by',
    'STAFF_MANAGEMENT.Group_Date': 'Date',
    'STAFF_MANAGEMENT.Group_Subcontractor': 'Subcontractor',
    'STAFF_MANAGEMENT.Column_Worker': 'Worker',
    'STAFF_MANAGEMENT.Column_Subcontractor': 'Subcontractor',
    'STAFF_MANAGEMENT.Column_Date': 'Date',
    'STAFF_MANAGEMENT.Column_FirstCheckIn': 'First check-in',
    'STAFF_MANAGEMENT.Column_LastCheckOut': 'Last check-out',
    'STAFF_MANAGEMENT.Column_TotalHours': 'Total hours',
    'STAFF_MANAGEMENT.WorkersHours_PartialHint': 'Includes completed sessions only. Some sessions are not closed.',
    'STAFF_MANAGEMENT.WorkersHours_NoCompletedHint': 'No completed sessions yet. Some sessions are not closed.',
    'STAFF_MANAGEMENT.WorkersHours_UnavailableHint': 'Hours are unavailable for some completed sessions.',
    'STAFF_MANAGEMENT.WorkersHours_UnavailableOpenHint': 'Hours are unavailable for some completed sessions. Some sessions are not closed.',
    'STAFF_MANAGEMENT.WorkersAction_ViewSession': 'View session in Attendance',
    'STAFF_MANAGEMENT.WorkersStatus_CheckedIn': 'Checked in',
    'STAFF_MANAGEMENT.WorkersStatus_NotCheckedIn': 'Not checked in',
    'STAFF_MANAGEMENT.WorkersStatus_CheckedOut': 'Checked out',
    'STAFF_MANAGEMENT.Text_WorkersCount': '{ count } workers',
    'STAFF_MANAGEMENT.Text_OneWorker': '1 worker',
    'STAFF_MANAGEMENT.Text_SessionsCount': '{ count } sessions',
    'STAFF_MANAGEMENT.AttendanceStatus_InProgress': 'In progress',
    'STAFF_MANAGEMENT.AttendanceStatus_FailedCheckout': 'Failed checkout',
    'STAFF_MANAGEMENT.AttendanceStatus_MissedCheckout': 'Missed checkout',
    'STAFF_MANAGEMENT.Text_Session': 'Session',
    'STAFF_MANAGEMENT.Text_SessionNumber': 'Session { number }',
    'STAFF_MANAGEMENT.Action_ToggleSessionDetails': 'Toggle session details',
    'STAFF_MANAGEMENT.Action_ManualCheckout': 'Manual check-out',
    'STAFF_MANAGEMENT.ManualCheckout_ConfirmTitle': 'Confirm manual check-out',
    'STAFF_MANAGEMENT.ManualCheckout_ConfirmText': 'Manually check out { worker } from { event }? Check-in: { checkIn }.',
    'STAFF_MANAGEMENT.ManualCheckout_By': 'Manually checked out by { name }',
    'STAFF_MANAGEMENT.ManualCheckout_UnknownActor': 'Manual check-out — author not specified',
    'STAFF_MANAGEMENT.ManualCheckout_Error': 'Manual check-out could not be completed.',
    'STAFF_MANAGEMENT.ManualCheckout_RefreshError': 'Manual check-out succeeded, but attendance data could not be refreshed. Reload the page to see the latest totals.',
    'STAFF_MANAGEMENT.ManualCheckout_Success': 'Manual check-out completed.',
    'STAFF_MANAGEMENT.ManualCheckout_StaleSession': 'This session is no longer available for manual check-out. Refresh the attendance data.',
    'STAFF_MANAGEMENT.AttendanceDetails_AllScansInsideZone': 'All scans inside the { radius } m zone',
    'STAFF_MANAGEMENT.AttendanceDetails_AllScansInsideZoneUnknownRadius': 'All scans inside the check-in zone',
    'STAFF_MANAGEMENT.AttendanceDetails_CheckoutRejected': 'Check-out rejected — outside the { radius } m zone',
    'STAFF_MANAGEMENT.AttendanceDetails_CheckoutRejectedGeneric': 'Check-out rejected',
    'STAFF_MANAGEMENT.AttendanceDetails_CheckoutRejectedWithReason': 'Check-out rejected — { reason }',
    'STAFF_MANAGEMENT.AttendanceDetails_MissedCheckoutNote': 'No check-out within 18 h of check-in — likely forgotten',
    'STAFF_MANAGEMENT.AttendanceDetails_CheckInAt': 'Check-in: { dateTime }',
    'STAFF_MANAGEMENT.AttendanceDetails_CheckOutAt': 'Check-out: { dateTime }',
    'STAFF_MANAGEMENT.AttendanceDetails_FailedCheckoutSummary': '{ count } attempts · { first }–{ last } · last ~{ distance } m from zone',
    'STAFF_MANAGEMENT.AttendanceWarning_WorkedMoreThanNineHours': 'Worked more than 9 h — longer than a standard working session.',
    'STAFF_MANAGEMENT.AttendanceWarning_InProgressOverNineHours': 'Over 9 h since check-in, no check-out yet. Auto-closes as "Missed checkout" after 18 h.',
    'STAFF_MANAGEMENT.Action_ViewMap': 'View map',
    'STAFF_MANAGEMENT.Text_NoLocation': 'No location',
    'STAFF_MANAGEMENT.ScanModal_Title': 'Scan location',
    'STAFF_MANAGEMENT.ScanModal_Title_OutsideZone': 'Scan outside zone',
    'STAFF_MANAGEMENT.ScanModal_Worker': 'Worker',
    'STAFF_MANAGEMENT.ScanModal_DateTime': 'Date and time',
    'STAFF_MANAGEMENT.ScanModal_Distance': 'Distance from check-in zone',
    'STAFF_MANAGEMENT.ScanModal_Location': 'Location',
    'STAFF_MANAGEMENT.ScanModal_ZoneDescription': 'Check-in zone: { latitude }, { longitude }; radius { radius } m',
    'STAFF_MANAGEMENT.ScanModal_CurrentZoneWarning': 'Historical zone unavailable. The circle shows the current exhibition check-in zone, which may differ from the zone at scan time.',
    'STAFF_MANAGEMENT.ScanGuidance_Label': 'Explain this GPS reading',
    'STAFF_MANAGEMENT.ScanGuidance_Audience_worker': 'Tell the worker',
    'STAFF_MANAGEMENT.ScanGuidance_Audience_manager': 'For the manager',
    'STAFF_MANAGEMENT.ScanGuidance_Title_missing_accuracy': 'No accuracy data',
    'STAFF_MANAGEMENT.ScanGuidance_Title_missing_zone': 'Zone at scan time unavailable',
    'STAFF_MANAGEMENT.ScanGuidance_Title_missing_distance': 'Distance to the zone unknown',
    'STAFF_MANAGEMENT.ScanGuidance_Title_outside': 'Point outside the zone',
    'STAFF_MANAGEMENT.ScanGuidance_Title_inside': 'Point inside the zone',
    'STAFF_MANAGEMENT.ScanGuidance_Title_imprecise': 'Location is imprecise',
    'STAFF_MANAGEMENT.ScanGuidance_Title_boundary': 'Point near the zone boundary',
    'STAFF_MANAGEMENT.ScanGuidance_Fact_missing_accuracy': 'GPS accuracy is unavailable for this scan.',
    'STAFF_MANAGEMENT.ScanGuidance_Fact_missing_zone': 'The check-in zone at the time of this scan was not saved.',
    'STAFF_MANAGEMENT.ScanGuidance_Fact_missing_distance': 'The distance to the check-in zone is unknown for this scan.',
    'STAFF_MANAGEMENT.ScanGuidance_Fact_outside': 'The phone shows a location { distance } from the check-in point.',
    'STAFF_MANAGEMENT.ScanGuidance_Fact_inside': 'The point and the blue circle are inside the check-in zone.',
    'STAFF_MANAGEMENT.ScanGuidance_Fact_imprecise': 'The phone reported a GPS accuracy of { accuracy } m.',
    'STAFF_MANAGEMENT.ScanGuidance_Fact_imprecise_exceeds_zone': 'The phone reported a GPS accuracy of { accuracy } m, greater than the zone radius.',
    'STAFF_MANAGEMENT.ScanGuidance_Fact_boundary_inside': 'The point is inside the zone, but the blue circle extends beyond its boundary.',
    'STAFF_MANAGEMENT.ScanGuidance_Fact_boundary_outside': 'On the map, the point is { outside } m outside the zone, and GPS accuracy is { accuracy } m.',
    'STAFF_MANAGEMENT.ScanGuidance_Fact_boundary_outside_small': 'On the map, the point is less than 0.1 m outside the zone, and GPS accuracy is { accuracy } m.',
    'STAFF_MANAGEMENT.ScanGuidance_Action_accepted': 'Scan accepted. There is no need to scan again.',
    'STAFF_MANAGEMENT.ScanGuidance_Action_retry_center': 'Move closer to the check-in point, stop, and scan the QR code again.',
    'STAFF_MANAGEMENT.ScanGuidance_Action_retry_entrance': 'Try scanning again near an open entrance, staying inside the check-in zone.',
    'STAFF_MANAGEMENT.ScanGuidance_Action_verify_location': 'Where are you now? Let\'s check the check-in location on the map together.',
    'STAFF_MANAGEMENT.ScanGuidance_Action_check_log': 'Check the result and reason in the Audit log.',
    'STAFF_MANAGEMENT.Column_ActionType': 'Action type',
    'STAFF_MANAGEMENT.Column_Result': 'Result',
    'STAFF_MANAGEMENT.Column_DateTime': 'Date and time',
    'STAFF_MANAGEMENT.Column_Reason': 'Reason',
    'STAFF_MANAGEMENT.Column_GpsAccuracy': 'GPS accuracy',
    'STAFF_MANAGEMENT.AuditAccuracy_Hint': 'Estimated GPS accuracy reported by the device, in metres. Lower values indicate better accuracy. The distance to the check-in point is a separate value. High (green): up to 20 m; Medium (yellow): over 20 m and up to 50 m; Low (red): over 50 m.',
    'STAFF_MANAGEMENT.AuditAccuracy_good': 'High',
    'STAFF_MANAGEMENT.AuditAccuracy_warning': 'Medium',
    'STAFF_MANAGEMENT.AuditAccuracy_poor': 'Low',
    'STAFF_MANAGEMENT.AuditAccuracy_unknown': 'No GPS',
    'STAFF_MANAGEMENT.Column_Device': 'Device',
    'STAFF_MANAGEMENT.Column_ScanLocation': 'Scan location',
    'STAFF_MANAGEMENT.Filter_Result': 'Result',
    'STAFF_MANAGEMENT.Filter_ActionType': 'Action type',
    'STAFF_MANAGEMENT.AuditAction_check_in': 'Check-in',
    'STAFF_MANAGEMENT.AuditAction_check_out': 'Check-out',
    'STAFF_MANAGEMENT.AuditAction_unknown': 'Unknown',
    'STAFF_MANAGEMENT.AuditResult_accepted': 'Accepted',
    'STAFF_MANAGEMENT.AuditResult_rejected': 'Rejected',
    'STAFF_MANAGEMENT.AuditResult_ignored': 'Ignored',
    'STAFF_MANAGEMENT.AuditResult_unknown': 'Unknown',
    'STAFF_MANAGEMENT.AuditReason_within_radius': 'Within radius',
    'STAFF_MANAGEMENT.AuditReason_outside_radius': 'Outside radius',
    'STAFF_MANAGEMENT.AuditReason_duplicate_scan': 'Already checked in',
    'STAFF_MANAGEMENT.AuditReason_AlreadyCheckedIn_Hint': 'Check out of this exhibition before checking in again.',
    'STAFF_MANAGEMENT.AuditReason_open_session_elsewhere': 'Checked in at another exhibition',
    'STAFF_MANAGEMENT.AuditReason_OpenSessionElsewhere_Hint': 'Check out of the other exhibition before checking in here.',
    'STAFF_MANAGEMENT.AuditReason_location_permission_denied': 'Location permission denied',
    'STAFF_MANAGEMENT.AuditReason_camera_permission_denied': 'Camera permission denied',
    'STAFF_MANAGEMENT.AuditReason_outside_schedule': 'Outside check-in period',
    'STAFF_MANAGEMENT.AuditReason_location_unavailable': 'Location unavailable',
    'STAFF_MANAGEMENT.AuditReason_no_open_session': 'No open session',
    'STAFF_MANAGEMENT.AuditReason_same_device': 'Used the same phone as { worker }',
    'STAFF_MANAGEMENT.AuditReason_manual_close': 'Manually checked out by { name }',
    'STAFF_MANAGEMENT.AuditReason_invalid_qr': 'Not the right code scanned',
    'STAFF_MANAGEMENT.AuditReason_outdated_qr': 'Outdated QR code scanned',
    'STAFF_MANAGEMENT.AuditReason_unknown': 'Unknown reason',
    'STAFF_MANAGEMENT.Action_View': 'View',
    'STAFF_MANAGEMENT.Error_LoadEvents': 'Staff management exhibitions could not be loaded.',
    'STAFF_MANAGEMENT.Error_LoadWorkerStatuses': 'Worker statuses could not be loaded. Please retry.',
    'STAFF_MANAGEMENT.Error_LoadWorkers': 'Workers and their hours could not be loaded. Please retry.',
    'DATE.Time_Zone': 'en-GB'
};

export default english;
